import React from 'react';
import { useDispatch } from 'react-redux';
import UIActions from '../../ui/UIActions';
import useAppSelector from '../redux/useAppSelector';
import styles from './RightPanelContainer.module.scss';

const RightPanelContainer = () => {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
  const { open, View, props } = useAppSelector((state) => state.ui.rightPanel);
  const dispatch = useDispatch();

  if (!open) return null;

  return (
    <div data-no-print className={styles.rightPanelContainer}>
      {View && (
        <View close={() => dispatch(UIActions.closeRightPanel())} {...props} />
      )}
    </div>
  );
};

export default RightPanelContainer;
